// extracted by mini-css-extract-plugin
export default {"listItem":"BookList_listItem__QxAZb"};